import React, {useState, useEffect} from 'react';
import Select, { components } from 'components/common/AppSelect'
import { observer } from 'mobx-react'
import AttachmentBoxAnalitics from "../module/AttachmentBoxAnalitics";
import AttachmentBoxAnaliticsbig from "../module/AttachmentBoxAnaliticsbig";
import AttachmentBoxAnaliticsbigout from "../module/AttachmentBoxAnaliticsbigout";
import TableExcelAnalitics from "../module/tableExcelAnalitics";
import Loading from '../../common/loading';
import LoadingCompleted from '../../common/loading_completed';

import LoadingFail from '../../common/loading_fail';
import '../index.css';
import GlobalState, {changepopupaddAttachmentAnalitics, changeActiveModeldatasetPrewbigquerypredict, changePrewdatasetbigquerypredict, changepopupaddAttachmentbig, changeActiveModeldatasetPrewbigquery, changePrewdatasetbigquery, changeInputDataset, changeOutputDataset, changeInputDatasetName, changeOutputDatasetName} from "../../../stores/GlobalState";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pool from "../../autorize/UserPool";


const PopupInfo = observer(() =>{
    
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const [attachments, setAttachments] = useState([]);
    const [nameDataset, setnameDataset] = useState("");
    const [nameDatasetout, setnameDatasetout] = useState("");
    const [nameDatasetprew, setnameDatasetprew] = useState("");
    const [predicate, setPredicate] = useState(false);
    const [nameDataset2, setnameDataset2] = useState("");
    const [objectid, setObjectid] = useState("");
    const [dataid, setDataid] = useState("");
    const [activebut, setActivebut] = useState(1);
    const [activebutOut, setActivebutOut] = useState(1);
    const [load, setLoad] = useState(0);
    const [file, setFile] = useState();
    const [save, setSave] = useState(false);
    const [typeBigquery, setTypeBigquery] = useState(1);
    const [typeCSWquery, setTypeCSWquery] = useState(1);
    const [typeBigqueryout, setTypeBigqueryout] = useState(1);
    const [typeBigquerytime, setTypeBigquerytime] = useState(false);
    const [statehead, setStatehead] = useState(1);
    const [textloading, setTextloading] = useState("Prediction  in Progress");
    const [textloadingcompleated, setTextloadingcompleated] = useState("Prediction Complete");
    const [optionmetrics, setOptionmetrics] = useState("");
    const [polden, setPolden] = useState(2);
    const [every, setEvery] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [timedata, setTimedata] = useState(false);

    const [inputdata, setInputdata] = useState(GlobalState.inputDatasetname);
    const [outputdata, setOutputdata] = useState(GlobalState.outputDatasetname);

    const [predictSeting, setpredictSeting] = useState(true);

    
    const GENERAL_ROW_ID = "__GENERAL__";
    const normalizeThreshold = (value) => {
        const num = Number(value);

        if (Number.isNaN(num)) return "";

        return Math.round((num + Number.EPSILON) * 100) / 100;
    };

    const [lowerSeting, setLowerSeting] = useState(
        normalizeThreshold(GlobalState.activeThresholdLower)
    );

    const [upperSeting, setUpperSeting] = useState(
        normalizeThreshold(GlobalState.activeThresholdUpper)
    );

    const metricsOptions = (GlobalState.activemodel?.lastTrain?.metrics || [])
        .filter(item => item.name !== "General")
        .map(item => ({
            value: item.id,
            label: item.name,
        }));

    const segmentOptions = [
        { value: GENERAL_ROW_ID, label: "General" },
        ...metricsOptions,
    ];
    const [top3, setTop3] = useState(false);
    const [impact, setImpact] = useState(false);
    


    const [minut, setMinut] = useState("00");
    const [hour, setHour] = useState("01");

    let options = [];
    let cswoptions = [];
    let datepiker = [];
    let hours = [];
    let minuts = [{ value: "00", label:"00" },{ value: "15", label:"15" },{ value: "30", label: "30" },{ value: "45", label: "45" }];
    let days = [{ value: "daily", label:"Day" },{ value: "weekly", label:"Week" },{ value: "monthly", label: "Month" }]
    for(var i = 1; i<=12; i++)
    {
        hours = [...hours, { value: i, label: i }]
    }

    const OTHER_ROW_ID = "__OTHER__";

    const getInitialThresholdRows = () => {
        const activeSegmentId = GlobalState.activeSegmentThresholdId;
        const lower = GlobalState.activeThresholdLower ?? 0.5;
        const upper = GlobalState.activeThresholdUpper ?? 0.5;

        // General
        if (!activeSegmentId || activeSegmentId === 0) {
            return [
                {
                    id: "general-row",
                    segmentId: GENERAL_ROW_ID,
                    lower,
                    upper,
                }
            ];
        }

        // Segment
        return [
            {
                id: `segment-row-${activeSegmentId}`,
                segmentId: activeSegmentId,
                lower,
                upper,
            },
            {
                id: "other-row",
                segmentId: OTHER_ROW_ID,
                lower,
                upper,
                isOther: true,
            }
        ];
    };

    const [thresholdRows, setThresholdRows] = useState(getInitialThresholdRows);

    useEffect(() => {
        setThresholdRows(prev => {
            if (prev.length > 0) return prev;
            return getInitialThresholdRows();
        });
    }, []);

    const addThresholdRow = () => {
        setThresholdRows(prev => [
            ...prev,
            {
                id: `row-${prev.length}-${Math.random()}`,
                segmentId: "",
                lower: GlobalState.activeThresholdLower ?? 0.5,
                upper: GlobalState.activeThresholdUpper ?? 0.5,
            }
        ]);
    };

    const updateThresholdRow = (id, field, value) => {
        setThresholdRows(prev =>
            prev.map(row =>
            row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const removeThresholdRow = (id) => {
        setThresholdRows(prev => prev.filter(row => row.id !== id));
    };


    const checkmodel = async()=>{
        setTextloading("Prediction  in Progress <br/><br/> You can close this window <br/>without waiting for the result.")
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
       
        const response = await fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction/last`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        const data = await response.json();
        if(data.state=='failed')
        {
            setLoad(4);
        }
        else if(data.state=='finished')
        {
            activebutOut==2?
            setTextloadingcompleated("Processing the saving of deployment")
            :
            setTextloadingcompleated("Prediction Complete");
            
            setLoad(3);
            //setLoad(2);
        }  
        else{
            setTimeout(function(){
                checkmodel();
            }, 30000)
        }
    }

    const startmodel = async() =>{
        
        
        if(activebut==2&&typeCSWquery==1)
        {
           
           if(nameDataset!=""&&objectid!=''&&(timedata==true||(timedata==false&&dataid!='')))
           {
                setStatehead(3)
                setPredicate(true);
                setLoad(1);
                var token = localStorage.getItem("token");
                const formData = new FormData();
                formData.append('file', attachments[0].file);
                if(timedata==false){
                    formData.append('tag', "Predict input");
                }
                localStorage.setItem("countactivetime", Date.now());
                if(dataid!='')
                {
                    const response = await fetch( Domen.url + `dataset/csv/upload?object_id=`+objectid+'&name='+nameDataset+'&date_column_name='+dataid, {
                        method: 'POST',
                        headers: {
                        'Authorization': token,
                        },
                        body: formData,
                    });
                    if(response.status>199&&response.status<399)
                        {
                        const data = await response.json();
                        changeInputDataset(data.id)
                        changeInputDatasetName(data.name)
                        const getUseGpu = () => {
                            const username = Pool.getCurrentUser()?.username;
                            return username === "admin";
                        };
                        var product = {
                            inputDataset: data.id,
                            upperThreshold: upperSeting,
                            lowerThreshold: lowerSeting,
                            // segmentThresholds: thresholdRows.reduce((acc, row) => {
                            //     if (
                            //         !row.segmentId ||
                            //         row.segmentId === OTHER_ROW_ID ||
                            //         row.segmentId === GENERAL_ROW_ID
                            //     ) return acc;

                            //     acc[row.segmentId] = {
                            //         upperThreshold: Number(row.upper),
                            //         lowerThreshold: Number(row.lower),
                            //     };

                            //     return acc;
                            // }, {}),
                            includeFeatureImpacts: impact,
                            includeTopFeatureDrivers: top3,
                            useGpu: getUseGpu()
                        };
                        if(GlobalState.outputDataset!='')
                        {
                            product = {
                                inputDataset: data.id,
                                outputDataset: GlobalState.outputDataset,
                                upperThreshold: upperSeting,
                                lowerThreshold: lowerSeting,
                                // segmentThresholds: thresholdRows.reduce((acc, row) => {
                                //     if (
                                //     !row.segmentId ||
                                //     row.segmentId === OTHER_ROW_ID ||
                                //     row.segmentId === GENERAL_ROW_ID
                                // ) return acc;

                                //     acc[row.segmentId] = {
                                //         upperThreshold: Number(row.upper),
                                //         lowerThreshold: Number(row.lower),
                                //     };

                                //     return acc;
                                // }, {}),
                                includeFeatureImpacts: impact,
                                includeTopFeatureDrivers: top3,
                                useGpu: getUseGpu()
                            };
                        }
                        
                        var token = localStorage.getItem("token");
                        localStorage.setItem("countactivetime", Date.now());
                        
                        setTextloading("Prediction  in Progress <br/><br/> You can close this window <br/>without waiting for the result.");
                        fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction`, {
                            method: 'POST',
                            headers: {
                                'Authorization': token,
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(product),
                        })
                        .then(response => 
                        {
                            if(response.status>199&&response.status<300)
                            {
                                
                                checkmodel()                       
                            }
                            else{
                                setLoad(3);
                            }
                            //setLoad(2);
                            //console.log(response)
                        })
                        .catch(error => {
                            console.error('There was an error with the fetch operation:', error);
                        });
        
        
                    }
                }
                else
                {
                    const getUseGpu = () => {
                        const username = Pool.getCurrentUser()?.username;
                        return username === "admin";
                    };
                    const response = await fetch( Domen.url + `dataset/csv/upload?object_id=`+objectid+'&name='+nameDataset, {
                        method: 'POST',
                        headers: {
                        'Authorization': token,
                        },
                        body: formData,
                    });
                    if(response.status>199&&response.status<399)
                        {
                        const data = await response.json();
                        changeInputDataset(data.id)
                        changeInputDatasetName(data.name)
        
                        var product = {
                            inputDataset: data.id,
                            upperThreshold: upperSeting,
                            lowerThreshold: lowerSeting,
                            // segmentThresholds: thresholdRows.reduce((acc, row) => {
                            //     if (
                            //         !row.segmentId ||
                            //         row.segmentId === OTHER_ROW_ID ||
                            //         row.segmentId === GENERAL_ROW_ID
                            //     ) return acc;

                            //     acc[row.segmentId] = {
                            //         upperThreshold: Number(row.upper),
                            //         lowerThreshold: Number(row.lower),
                            //     };

                            //     return acc;
                            // }, {}),
                            includeFeatureImpacts: impact,
                            includeTopFeatureDrivers: top3,
                            useGpu: getUseGpu()
                            
                        };
                        if(GlobalState.outputDataset!='')
                        {
                            product = {
                                inputDataset: data.id,
                                outputDataset: GlobalState.outputDataset,
                                upperThreshold: upperSeting,
                                lowerThreshold: lowerSeting,
                                // segmentThresholds: thresholdRows.reduce((acc, row) => {
                                //     if (
                                //     !row.segmentId ||
                                //     row.segmentId === OTHER_ROW_ID ||
                                //     row.segmentId === GENERAL_ROW_ID
                                // ) return acc;

                                //     acc[row.segmentId] = {
                                //         upperThreshold: Number(row.upper),
                                //         lowerThreshold: Number(row.lower),
                                //     };

                                //     return acc;
                                // }, {}),
                                includeFeatureImpacts: impact,
                                includeTopFeatureDrivers: top3,
                                useGpu: getUseGpu()
                            };
                        }
                        
                        var token = localStorage.getItem("token");
                        localStorage.setItem("countactivetime", Date.now());
                        
                        setTextloading("Prediction  in Progress <br/><br/> You can close this window <br/>without waiting for the result.");
                        fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction`, {
                            method: 'POST',
                            headers: {
                                'Authorization': token,
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(product),
                        })
                        .then(response => 
                        {
                            if(response.status>199&&response.status<300)
                            {
                                
                                checkmodel()                       
                            }
                            else{
                                setLoad(3);
                            }
                            //setLoad(2);
                            //console.log(response)
                        })
                        .catch(error => {
                            console.error('There was an error with the fetch operation:', error);
                        });
        
        
                    }
                }
                
                

            }
            else
            {
            setLoad(4)
            }
        }
        else
        {
            setStatehead(3)
            setPredicate(true);
            setLoad(1);
            const getUseGpu = () => {
                const username = Pool.getCurrentUser()?.username;
                return username === "admin";
            };
            var product = {
                inputDataset: GlobalState.inputDataset,
                upperThreshold: upperSeting,
                lowerThreshold: lowerSeting,
                // segmentThresholds: thresholdRows.reduce((acc, row) => {
                //     if (
                //                     !row.segmentId ||
                //                     row.segmentId === OTHER_ROW_ID ||
                //                     row.segmentId === GENERAL_ROW_ID
                //                 ) return acc;

                //     acc[row.segmentId] = {
                //         upperThreshold: Number(row.upper),
                //         lowerThreshold: Number(row.lower),
                //     };

                //     return acc;
                // }, {}),
                includeFeatureImpacts: impact,
                includeTopFeatureDrivers: top3,
                useGpu: getUseGpu()
                
                //outputDataset: GlobalState.activemodel.lastTrain.featureDataset,
            };
            setTextloading("Prediction  in Progress <br/><br/> You can close this window <br/>without waiting for the result.")
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
             console.log('trefatesta');
            fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(product),
            })
            .then(response => 
            {
                 
                if(response.status>199&&response.status<399)
                {
                    checkmodel()      
                    //setTextloadingcompleated("Processing the saving of deployment");
                    //setLoad(3);            
                }
                else{
                    console.log(response.status);
                    setLoad(4);
                }
                //setLoad(2);
                //console.log(response)
            })
            .catch(error => {
                console.error('There was an error with the fetch operation:', error);
            });
        }
        
    }

    const startmodel2 = () =>{
        
        setLoad(1);

        
        var product = {
            inputDataset: GlobalState.inputDataset,
            outputDataset: GlobalState.outputDataset,
            upperThreshold: upperSeting,
            lowerThreshold: lowerSeting,
            // segmentThresholds: thresholdRows.reduce((acc, row) => {
            //     if (
            //                         !row.segmentId ||
            //                         row.segmentId === OTHER_ROW_ID ||
            //                         row.segmentId === GENERAL_ROW_ID
            //                     ) return acc;

            //     acc[row.segmentId] = {
            //         upperThreshold: Number(row.upper),
            //         lowerThreshold: Number(row.lower),
            //     };

            //     return acc;
            // }, {}),
            includeFeatureImpacts: impact,
            includeTopFeatureDrivers: top3
        };
        
        localStorage.setItem("countactivetime", Date.now());
        var token = localStorage.getItem("token");
        fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction`, {
            method: 'POST',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(product),
        })
        .then(response => 
        {
            if(response.status>199&&response.status<399)
            {
               
                setTextloadingcompleated("Processing the saving of deployment");
                setLoad(3);            
            }
            else{
                setLoad(4);
            }
            //setLoad(2);
            //console.log(response)
        })
        .catch(error => {
            console.error('There was an error with the fetch operation:', error);
        });
        
    }
    
    
    const changesavemodel = () =>{  
        var h = hour;
        if(polden==2)
        {
            if(h<12)
            {
                h = h*1+12;
            }
            else
            {
                h = "00";
            }
        }
        if(polden==1)
        {
            if(h<10)
            {
                h = "0"+h;
            }
            
        }
        if(statehead>=3)
        {
            var d = new Date(startDate);
            var y = d.getFullYear();
            var m = d.getMonth()+1;
            var a = d.getDate();
            
            if(m<10)
            {
                m = "0"+m;
            }
            if(a<10)
            {
                a = "0"+a;
            }
            var product = {
                inputDataset: GlobalState.inputDataset,
                outputDataset: GlobalState.outputDataset,
                upperThreshold: upperSeting,
                lowerThreshold: lowerSeting,
                // segmentThresholds: thresholdRows.reduce((acc, row) => {
                //     if (
                //                     !row.segmentId ||
                //                     row.segmentId === OTHER_ROW_ID ||
                //                     row.segmentId === GENERAL_ROW_ID
                //                 ) return acc;

                //     acc[row.segmentId] = {
                //         upperThreshold: Number(row.upper),
                //         lowerThreshold: Number(row.lower),
                //     };

                //     return acc;
                // }, {}),
                includeFeatureImpacts: impact,
                            includeTopFeatureDrivers: top3,
                startTime: y+"-"+m+"-"+a+"T"+h+":"+minut+":00.682Z",
                periodicity: every
            };
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            
            fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/deploy`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },
                body: JSON.stringify(product),
            })
            .then(response => {
                if(response.status>199&&response.status<300)
                {
                    //setStatehead(4); 
                    setTextloadingcompleated("Schedule save");
                    setStatehead(6);
                    setLoad(2);
                    if(statehead==5){
                        //changepopupaddAttachmentAnalitics()test

                    }               

                }
                else{
                    setLoad(5);
                }
                
            })
            .catch(error => {
                console.error('There was an error with the fetch operation:', error);
            })
           
        }
 
    }
    const changesavemodel2 = () =>{  
       const getUseGpu = () => {
            const username = Pool.getCurrentUser()?.username;
            return username === "admin";
        };
        if(statehead>=3)
        {
           
            var product = {
                inputDataset: GlobalState.inputDataset,
                outputDataset: GlobalState.outputDataset,
                upperThreshold: upperSeting,
                lowerThreshold: lowerSeting,
                // segmentThresholds: thresholdRows.reduce((acc, row) => {
                //     if (
                //                     !row.segmentId ||
                //                     row.segmentId === OTHER_ROW_ID ||
                //                     row.segmentId === GENERAL_ROW_ID
                //                 ) return acc;

                //     acc[row.segmentId] = {
                //         upperThreshold: Number(row.upper),
                //         lowerThreshold: Number(row.lower),
                //     };

                //     return acc;
                // }, {}),
                includeFeatureImpacts: impact,
                includeTopFeatureDrivers: top3,
                useGpu: getUseGpu()
                
            };
            var token = localStorage.getItem("token");
            localStorage.setItem("countactivetime", Date.now());
            
            fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction`, {
                method: 'POST',
                headers: {
                    'Authorization': token,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(product),
            })
            .then(response => {
                if(response.status>199&&response.status<300)
                {
                    //setStatehead(4); 
                    setTextloadingcompleated("Schedule save");
                    setStatehead(6);
                    setLoad(2);
                    if(statehead==5){
                        //changepopupaddAttachmentAnalitics()test

                    }               

                }
                else{
                    setLoad(5);
                }
                
            })
            .catch(error => {
                console.error('There was an error with the fetch operation:', error);
            })
           
        }
 
    }
    const activesave = (a) =>{
        setActivebut(a)
    }
    const activesaveOut = (a) =>{
        if(a==1)
        {
            if(activebut==1)
            {
                setActivebutOut(a)
            }
        }
        if(a==2)
        {
            if(activebut==2)
            {
                setActivebutOut(a)
            }
        }
        
    }

    async function uploadFile(fileurl) {
        if (!fileurl) return;

        localStorage.setItem("countactivetime", Date.now());
        const token = localStorage.getItem("token");

        await fetch(fileurl, {
            method: "GET",
            headers: {
            Authorization: token,
            "Content-Type": "application/json",
            },
        });
        }

        useEffect(() => {
        if (file) {
            uploadFile(file);
        }
    }, [file]);

    const setStatehead0 = async(a) =>{

            setStatehead(a)
            if(a==1){
            setAttachments([]);
            setnameDataset("");
            setnameDatasetout("");
            setnameDatasetprew("");
            setPredicate(false);
            setnameDataset2("");
            setObjectid("");
            setDataid("");
            setActivebut(1);
            setActivebutOut(1);
            setLoad(0);
            setFile();
            setSave(false);
            setTypeBigquery(1);
            setTypeCSWquery(1);
            setTypeBigqueryout(1);
            setTypeBigquerytime(false);
            setStatehead(1);
            setOptionmetrics("");
            setPolden(2);
            setEvery("");
            }
            if(a==2.5){
                if(nameDataset!="")
                {
                    if(timedata==false){
                        var product = {
                            table: GlobalState.tablebigquery,
                            name: nameDataset,
                            objectId: objectid,
                            credentials: GlobalState.credentialbigquery,
                            dateColumnName: dataid,
                            tag: ["Predict input"]
                        };
                    }
                    else{
                        var product = {
                            table: GlobalState.tablebigquery,
                            name: nameDataset,
                            objectId: objectid,
                            credentials: GlobalState.credentialbigquery,
                            dateColumnName: dataid
                           
                        };
                    }
                    
                    var token = localStorage.getItem("token");
                    localStorage.setItem("countactivetime", Date.now());
                    const response = await fetch( Domen.url + `dataset/bigQuery/connect`, {
                        method: 'POST',
                        headers: {
                        'Authorization': token,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(product),
                    });
                    
                    
                    if(response.status>199||response.status<399)
                    {
                    const data = await response.json();
                    changeInputDataset(data.id)
                    changeInputDatasetName(data.name)
                    }
                    else
                    {
                    //setLoad(5)
                    }
                }
            }
    }

    async function getLinkOutline(){
        
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `model/`+GlobalState.activemodel?.id+`/prediction/last/generateDownloadLink`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        if(response.status=="200")
        {
            const data = await response.json();
            window.location.href=data.url;
        }
        else
        {
            setLoad(3)
        }
    }

    const openlinkoutput = ()=>{
        getLinkOutline()
    }

    GlobalState.dataset?.map((n, id)=>
        n.source=='bigquery'?
        options = [...options, { value: n.id, label: n.name }]
        :
        <></>
    )
    GlobalState.dataset?.map((n, id)=>
        n.source!='bigquery'?
        cswoptions = [...cswoptions, { value: n.id, label: n.name }]
        :
        <></>
    )
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '373px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 15,
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(245, 197, 56, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            width: '373px',
           
            marginTop: '-7px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(245, 197, 56, 1)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(45, 50, 57, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(45, 50, 57, 1))', 
            }
            }),
    };
    const customStyles2 = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '264px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 15,
            position:'relative',
            zIndex: 1
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(245, 197, 56, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            width: '264px',
            paddingLeft: '20px',
            marginTop: '-7px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(245, 197, 56, 1)',
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(235, 115, 27, 1)' : 'rgba(255, 255, 255, 1)',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(235, 115, 27, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(45, 50, 57, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(45, 50, 57, 1))', 
            }
            }),
    };
    const customStyles3 = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '200px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 15,
            zIndex:9999999,
            position:'relataive',
            borderRadius: '8px'
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(245, 197, 56, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            width: '200px',

            marginTop: '-7px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(245, 197, 56, 1)',
            zIndex:9999,
            position:'absolute'
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(245, 197, 56, 1)' : 'rgba(255, 255, 255, 1)',
            zIndex:9999,
            position:'relative',
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(245, 197, 56, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(245, 197, 56, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(245, 197, 56, 1)', 
            }
            }),
    };
    const customStyles4 = {
        control: (provided, state) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            display: 'flex',
            flexWrap: 'nowrap',
            width: '100px',
            height: '38px',
            color: 'rgba(245, 197, 56, 1)',
            border: '0px solid rgba(244, 245, 247, 1)',
            boxShadow: 'none',
            fontSize: 15,
            zIndex:9999999,
            position:'relataive'
        }),
        input: (provided) => ({
            ...provided,
            color: 'rgba(245, 197, 56, 1)',
        }),
        
        menu: (provided) => ({
            ...provided,
            background: 'rgba(45, 50, 57, 1)',
            width: '100px',
            maxHeight: '110px',
            height:'110px',
            paddingBottom:'10px',
            marginTop: '-7px',
            boxShadow: 'none',
            cursor: 'pointer',
            color: 'rgba(245, 197, 56, 1)',
            zIndex:9999,
            position:'absolute'
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: 12,
            paddingLeft: 0,
            color: state.isSelected ? 'rgba(245, 197, 56, 1)' : 'rgba(255, 255, 255, 1)',
            zIndex:9999,
            position:'relative',
           
            
            backgroundColor: 'rgba(255, 255, 255, 0)', 
            '&:hover': {
                color: 'rgba(245, 197, 56, 1)',
            },
            '&:focus': {
                backgroundColor: 'rgba(245, 197, 56, 1)', 
            },
            '&:active': {
                backgroundColor: 'rgba(245, 197, 56, 1)', 
            }
            }),
    };
    const DropdownIndicator = props => {
        return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {
                props.selectProps.menuIsOpen ? 
                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="9" cy="12.5" r="2" fill="white"/>
                        <path d="M1 9.5L9.24242 1.5L17 9.5" stroke="white"/>
                    </svg>
                    : 
                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="2" r="2" transform="matrix(1 0 0 -1 7 4.5)" fill="white"/>
                        <path d="M1 5.5L9.24242 13.5L17 5.5" stroke="white"/>
                    </svg>

                }
            </components.DropdownIndicator>
        )
        );
    };

    const adddatasetprewWorkspacecheck = async (a) => {

        setOptionmetrics(a);

        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `dataset/`+a+`/preview`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        
        if(response.status=="200")
        {
            const data = await response.json();
            changeActiveModeldatasetPrewbigquery(data.sample?.slice(0, 3));
            changePrewdatasetbigquery(data);

            changeActiveModeldatasetPrewbigquerypredict(data.sample?.slice(0, 3));
            changePrewdatasetbigquerypredict(data);

 
            setStatehead(2);
            changeInputDataset(data.id);
            changeInputDatasetName(data.name);
            setInputdata(data.name)
        } 
        else
        {
            setLoad(5)
        }
    }
    const adddatasetprewWorkspacecheck1 = async (a) => {

        setOptionmetrics(a);
       
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        const response = await fetch(Domen.url + `dataset/`+a+`/preview`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        })
        
        if(response.status=="200")
        {
            const data = await response.json();
            changeActiveModeldatasetPrewbigquery(data.sample?.slice(0, 3));
            changePrewdatasetbigquery(data);
            changeActiveModeldatasetPrewbigquerypredict(data.sample?.slice(0, 3));
            changePrewdatasetbigquerypredict(data);
   
            changeOutputDataset(data.id)
            changeOutputDatasetName(data.name)
            setOutputdata(data.name)
            if(typeBigquerytime)
            {
                //setStatehead(4);

                // setTextloadingcompleated("Processing the saving of deployment");
                // setStatehead(3.5);
                // setLoad(1)
                // startmodel2();
                
                // console.log('tyre')

                setStatehead(5.5);
            }
            else{
                setStatehead(5);
            }
            
            //changesavemodel()
        } 
        else
        {
            setLoad(5)
        }
    }

    const setTypeBigquery0 = (a)=>
    {
        setTypeBigquery(a);
    }
    const setTypeCSWquery0 = (a)=>
    {
        setTypeCSWquery(a);
    }
    const setTypeBigqueryout0 = (a)=>
    {
        setTypeBigqueryout(a);
        setLoad(1)
    }
    
    const setOptionmetrics0 = (a)=>
    {
        adddatasetprewWorkspacecheck(a)
    }
    const setOptionmetrics1 = (a)=>
    {
        adddatasetprewWorkspacecheck1(a)
    }
    
    return (
        <div className="popupInfofon analitdeploy">
            <div className="popupInfo addwork attach analitdeployscroll" style={{maxWidth: "calc(940px)"}}>
                <div className='top-element'>
                    <div className='namepopup'>
                        {langv?.deploy?.text2}
                    </div>
                    {/* <div className='separator'></div> */}
                    <div className='buttonspopup' style={{minWidth: "80px"}}>
                        {
                            statehead==5?
                            <></>
                            // <div className={statehead>4&&every!=''?'buttonsave active':'buttonsave'} style={{marginRight: "8px"}} onClick={()=>changesavemodel()}>{langv?.deploy?.text3}</div>
                            :
                            <></>
                        }
                        {/* <div className={statehead>4&&every!=''?'buttonsave active':'buttonsave'} onClick={()=>changesavemodel()}>{langv?.deploy?.text3}</div> */}
                        <div className='buttonexit' onClick={changepopupaddAttachmentAnalitics}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='stage_atach'>
                {
                    <>
                        
                        <div className={statehead>1?'buton_stage inactive':statehead==1?'buton_stage active':<></>} onClick={()=>setStatehead0(1)} style={{width:"175px"}}>
                        {langv?.deploy?.text4}
                        </div>
                        {
                            // onClick={()=>setStatehead0(2)}
                            statehead>1?
                            <div className={statehead>2?'buton_stage inactive':statehead==2?'buton_stage active':'buton_stage'}  style={{width:"175px"}}>
                                {langv?.deploy?.text5}
                            </div>
                            :
                            <div className={statehead>2?'buton_stage inactive':statehead==2?'buton_stage active':'buton_stage'}  style={{width:"175px"}}>
                                {langv?.deploy?.text5}
                            </div>
                        }
                      
                        {
                            statehead>2?
                                activebut==1?
                                <div className={statehead>2.5?'buton_stage inactive':statehead==2.5?'buton_stage active':'buton_stage'} onClick={()=>setStatehead0(2.5)} style={{width:"175px"}}>
                                    {langv?.deploy?.text6}
                                </div>
                                :
                                <></>
                                :
                                activebut==1?
                                <div className={statehead>2.5?'buton_stage inactive':statehead==2.5?'buton_stage active':'buton_stage'} style={{width:"175px"}}>
                                    {langv?.deploy?.text6}
                                </div>
                                :
                                <></>
                        }

                        {
                            statehead>2?
                                activebut==2?
                                <div className={statehead>2.1?'buton_stage inactive':statehead==2.1?'buton_stage active':'buton_stage'} onClick={()=>setStatehead0(2.1)} style={{width:"175px"}}>
                                    Prediction settings
                                </div>
                                :
                                <></>
                                :
                                activebut==2?
                                <div className={statehead>2.1?'buton_stage inactive':statehead==2.1?'buton_stage active':'buton_stage'} style={{width:"175px"}}>
                                    Prediction settings
                                </div>
                                :
                                <></>
                        }
                        
                        {
                            statehead>2.5?
                                activebut==2?
                                <div className={statehead>3?'buton_stage inactive':statehead==3?'buton_stage active':'buton_stage'} onClick={()=>setStatehead0(3)}>
                                    {langv?.deploy?.text7}
                                </div>
                                :
                                <></>
                                :
                                activebut==2?
                                <div className={statehead>3?'buton_stage inactive':statehead==3?'buton_stage active':'buton_stage'} >
                                    {langv?.deploy?.text7}
                                </div>
                                :
                                <></>
                        }
                        {
                            statehead>=1?
                                
                                activebut==1?
                                    statehead>=3?
                                    <div className={statehead>5?'buton_stage inactive':statehead==5?'buton_stage active':'buton_stage'} onClick={()=>typeBigquerytime?setStatehead0(5.5):setStatehead0(5)}>
                                        {/* {langv?.deploy?.text8} */}
                                        Prediction settings
                                        
                                    </div>
                                    :
                                    <div className={statehead>5?'buton_stage inactive':statehead==5?'buton_stage active':'buton_stage'} >
                                        {/* {langv?.deploy?.text8} */}
                                        Prediction settings
                                        
                                    </div>
                                :
                                <></>


                                :


                                activebut==1?
                                <div className={statehead>5?'buton_stage inactive':statehead==5?'buton_stage active':'buton_stage'}>
                                    {langv?.deploy?.text8}
                                </div>
                                :
                                <></>
                        }
                        {
                            statehead>=1?
                                activebut==1?
                                <div className={statehead>6?'buton_stage inactive':statehead==6?'buton_stage active':'buton_stage'} >
                                    {/* {langv?.deploy?.text8} */}
                                    Prediction
                                </div>
                                :
                                <></>
                                :
                                <></>
                        }
                        
                    </>
                }
                </div>
                <div className={activebut==1?'adddataset-element bigdata center':'adddataset-element'}>
                    {
                        statehead==1&&load==0?
                        <>
                            <div className="tableexcel_select" style={{width:"100%", marginBottom:"24px"}}>
                                <div className={activebut==1?"but_depluyment active":"but_depluyment"} onClick={()=>activesave(1)}>
                                {langv?.deploy?.text9}
                                </div>
                                <div className={activebut==2?"but_depluyment active":"but_depluyment"} onClick={()=>activesave(2)}>
                                {langv?.deploy?.text10}
                                </div>
                            </div>
                        </>
                        :
                        <></>
                    }
                    {
                        statehead==2.5?
                        <div className="tableexcel_select" style={{width:"100%"}}>
                            <div className={activebut==1?activebutOut==1?"but_depluyment active":"but_depluyment":"but_depluyment inactive"} onClick={()=>activesaveOut(1)}>
                            {langv?.deploy?.text9}
                            </div>
                            <div className={activebut==2?activebutOut==2?"but_depluyment active":"but_depluyment":"but_depluyment inactive"} onClick={()=>activesaveOut(2)}>
                            {langv?.deploy?.text10}
                            </div>
                        </div>
                        :
                        <></>
                    }
                    {
                        statehead==2.5?
                            <>
                                {
                                    activebutOut==2?
                                    <div className="but_next_stepanalitics_line">
                                        <div className="but_next_stepanalitics" onClick={()=>startmodel()}>{langv?.deploy?.text25}</div>
                                    </div>
                                    :
                                    <></>
                                }
                                   
                            </>
                        :
                        <></>
                    }
                    {
                        statehead==3.5?
                        <div className='loading_container'>
                        <div className='loading_lines' style={{marginTop: "0px"}}>
                            {
                                activebut==1?
                                    <div className='bq_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {textloadingcompleated}/>
                                           
                                                {/* <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div> */}
                                              
                                            
                                            </>
                                    }
                                    </div>
                                    :
                                    <div className='csv_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {textloadingcompleated}/>
                                           
                                                <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div>
                                              
                                            
                                            </>
                                    }
                                    </div>
                            }
                        </div>  
                        </div>
                        :
                        <></> 
                    }
                    {
                        statehead==6?
                        <div className='loading_container'>
                        <div className='loading_lines' style={{marginTop: "0px"}}>
                            {
                                activebut==1?
                                    <div className='bq_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {'Deployment success'}/>
                                           
                                                {/* <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div> */}
                                              
                                            
                                            </>
                                    }
                                    </div>
                                    :
                                    <div className='csv_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {textloadingcompleated}/>
                                           
                                                <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div>
                                              
                                            
                                            </>
                                    }
                                    </div>
                            }
                        </div>  
                        </div>
                        :
                        <></> 
                    }
                    {
                        statehead==3?
                        <div className='loading_container' >
                        <div className='loading_lines' style={{marginTop: "0px"}}>
                            {
                                activebut==1?
                                    <div className='bq_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {textloadingcompleated}/>
                                           
                                                {/* <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div> */}
                                              
                                            
                                            </>
                                    }
                                    </div>
                                    :
                                    <div className='csv_load'>
                                    {
                                        load==1?
                                        <Loading text = {textloading}/>
                                        :
                                            load==4?
                                            <LoadingFail text = {textloadingcompleated}/>
                                            :
                                            <>
                                            <LoadingCompleted text = {textloadingcompleated}/>
                                           
                                                <div onClick={()=>openlinkoutput()} className="but_next_stepanalitics_line yui">
                                                    <div className="but_next_stepanalitics downloads">{langv?.deploy?.text11}</div>
                                                </div>
                                              
                                            
                                            </>
                                    }
                                    </div>
                            }
                        </div>  
                        </div>
                        :
                        <></> 
                    }                     
                    {
                        activebut==1?
                            !attachments[0]?.file && (statehead==1) && load==0?

                                <>
                                    <div className='typedatasets'>
                                        <span onClick={()=>setTypeBigquery0(1)}>
                                            {
                                                typeBigquery==1?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            
                                            {langv?.deploy?.text26}
                                        </span>
                                        <span onClick={()=>setTypeBigquery0(2)}>
                                            {
                                                typeBigquery==2?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            {langv?.deploy?.text27}
                                        </span>
                                    </div>
                                    {
                                        typeBigquery==1?
                                        <input id="website" type="text" placeholder="Type Big Query Project ID" class="pop-input datasetname" value={nameDatasetprew} onChange={(event) => setnameDatasetprew(event.target.value)} style={{marginBottom:"24px"}}></input>
                                        :
                                        <Select 
                                            components={{ DropdownIndicator }}
                                            options={options} 
                                            styles={customStyles} 
                                            classNamePrefix='filter'
                                            className='selectproduct'
                                              
                                            placeholder={<div className='selectplace active'>{langv?.deploy?.text15}</div>}
                                            onChange={(option) => setOptionmetrics0(option.value)}
                                        />
                                    }
                                </>
                            :
                            <> </>
                        :
                        <></>
                    }
                    {
                        activebut==2?
                            !attachments[0]?.file && (statehead==1)?
                                <>
                                    <div className='typedatasets' style={{marginBottom:"0px"}}>
                                        <span onClick={()=>setTypeCSWquery0(1)}>
                                            {
                                                typeCSWquery==1?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            
                                            New  CSV Table ID
                                        </span>
                                        <span onClick={()=>setTypeCSWquery0(2)}>
                                            {
                                                typeCSWquery==2?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            Select Input Table from Datasets
                                        </span>
                                    </div>
                                    {
                                        typeCSWquery==1?
                                        <></>
                                        :
                                        <Select 
                                            components={{ DropdownIndicator }}
                                            options={cswoptions} 
                                            styles={customStyles} 
                                            classNamePrefix='filter'
                                            className='selectproduct'
                                              
                                            placeholder={<div className='selectplace active'>{langv?.deploy?.text15}</div>}
                                            onChange={(option) => setOptionmetrics0(option.value)}
                                        />
                                    }
                                </>
                            :
                            <></>
                            :
                        <></>
                    }
                    {
                        activebutOut==1?
                            !attachments[0]?.file && (statehead==2.5)?

                                <>
                                    <div className='typedatasets' style={{marginTop:"24px"}}>
                                        <span onClick={()=>setTypeBigqueryout0(1)}>
                                            {
                                                typeBigqueryout==1?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            
                                            {langv?.deploy?.text13}
                                        </span>
                                        <span onClick={()=>setTypeBigqueryout0(2)}>
                                            {
                                                typeBigqueryout==2?
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                </svg>
                                                :
                                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.6">
                                                    <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                    </g>
                                                </svg>
                                            }
                                            {langv?.deploy?.text28}
                                            
                                        </span>
                                    </div>
                                    {
                                        typeBigqueryout==1?
                                        <div className='line_vvod_anali'>
                                            <input id="website" type="text" placeholder="Type Big Query Project ID" class="pop-input datasetname" value={nameDatasetout} onChange={(event) => setnameDatasetout(event.target.value)}></input>
                                            <div className='onetime_but' onClick={()=>setTypeBigquerytime(!typeBigquerytime)}>
                                                {
                                                    typeBigquerytime?
                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                        <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                    </svg>
                                                    :
                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.6">
                                                        <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                        </g>
                                                    </svg>
                                                }
                                                {langv?.deploy?.text29}
                                               
                                            </div>
                                        </div>
                                        :
                                        <div className='line_vvod_anali'>
                                            <Select 
                                                components={{ DropdownIndicator }}
                                                options={options} 
                                                styles={customStyles} 
                                                classNamePrefix='filter'
                                                className='selectproduct'
                                                  
                                                placeholder={<div className='selectplace active'>{langv?.deploy?.text30}</div>}
                                                onChange={(option) => setOptionmetrics1(option.value)}
                                            />
                                            <div className='onetime_but' onClick={()=>setTypeBigquerytime(!typeBigquerytime)}>
                                                {
                                                    typeBigquerytime?
                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="12.1484" cy="12.3008" r="4" fill="#33A753"/>
                                                        <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="#33A753" stroke-width="1.5"/>
                                                    </svg>
                                                    :
                                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.6">
                                                        <path d="M11.1484 3.87813C11.7672 3.52087 12.5296 3.52087 13.1484 3.87813L18.9427 7.22343C19.5615 7.5807 19.9427 8.24095 19.9427 8.95548L19.9427 15.6461C19.9427 16.3606 19.5615 17.0209 18.9427 17.3781L13.1484 20.7234C12.5296 21.0807 11.7672 21.0807 11.1484 20.7234L5.35421 17.3781C4.73541 17.0209 4.35421 16.3606 4.35421 15.6461L4.35421 8.95548C4.35421 8.24095 4.73541 7.5807 5.35421 7.22343L11.1484 3.87813Z" stroke="white" stroke-width="1.5"/>
                                                        </g>
                                                    </svg>
                                                }
                                                {langv?.deploy?.text29}
                                            </div>
                                        </div>
                                    }

                                </>
                            :
                            <> </>
                        :
                        <></>
                    }
                    {
                        statehead==1&&typeBigquery==1?
                        <>
                            {
                                activebut!=0?
                                    activebut==2?
                                        typeCSWquery==1?
                                        <>
                                        <div style={{marginBottom: "50px", minWidth: "100%"}}></div>
                                        <AttachmentBoxAnalitics {...{ attachments, setAttachments, setStatehead }} />
                                        </>
                                        :
                                        <></>
                                    :
                                    <AttachmentBoxAnaliticsbig {...{ attachments, setAttachments, setStatehead, nameDatasetprew, load, setLoad }} />
                                :
                                <></>
                            }
                        </>
                        :
                        <></>
                    }
                    {
                        statehead==2.5&&activebutOut==1?
                        <>
                            {
                                typeBigqueryout==1?
                                    
                                <AttachmentBoxAnaliticsbigout {...{ attachments, setAttachments, setStatehead, nameDatasetout, typeBigquerytime, save, setTextloadingcompleated, setLoad }} />
                                :
                                <></>
                            }
                        </>
                        :
                        <></>
                    }
                    {
                        statehead==2.1?
                            <>
                                <div className='predict_seting_line predict_seting_line_title'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.6476 8.33398C9.70071 9.05188 8.80474 9.83457 7.96615 10.6764C4.01483 14.6264 2.01417 19.0306 3.49521 20.5116C4.97626 21.9927 9.38051 19.992 13.3304 16.0407C14.1723 15.2021 14.955 14.3062 15.6729 13.3593" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M15.6715 13.3559C18.0015 16.4486 18.9504 19.3593 17.8 20.5097C16.3176 21.9908 11.9147 19.9901 7.9634 16.0388C4.01486 12.0888 2.0142 7.68461 3.49525 6.20356C4.64424 5.05318 7.55354 6.0021 10.6462 8.33204" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.95215 13.3548C9.95215 13.5391 10.0253 13.7158 10.1556 13.846C10.2859 13.9763 10.4626 14.0495 10.6468 14.0495C10.8311 14.0495 11.0078 13.9763 11.138 13.846C11.2683 13.7158 11.3415 13.5391 11.3415 13.3548C11.3415 13.1706 11.2683 12.9939 11.138 12.8636C11.0078 12.7333 10.8311 12.6602 10.6468 12.6602C10.4626 12.6602 10.2859 12.7333 10.1556 12.8636C10.0253 12.9939 9.95215 13.1706 9.95215 13.3548Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.4405 7.27213C13.0029 7.1971 13.0029 6.57051 13.4405 6.49409C14.2137 6.36016 14.9294 5.99873 15.4961 5.45601C16.0629 4.91328 16.4549 4.2139 16.6222 3.44724L16.6486 3.32637C16.743 2.89567 17.3571 2.89289 17.4544 3.32359L17.4877 3.46253C17.6621 4.22539 18.0579 4.91978 18.6254 5.45859C19.1928 5.99741 19.9068 6.35667 20.6777 6.49131C21.1167 6.56912 21.1167 7.19849 20.6777 7.27491C19.9068 7.40955 19.1928 7.76881 18.6254 8.30762C18.0579 8.84644 17.6621 9.54083 17.4877 10.3037L17.4544 10.4426C17.3571 10.8733 16.743 10.8719 16.6486 10.4398L16.6208 10.3204C16.4538 9.55345 16.0618 8.85377 15.4951 8.31078C14.9283 7.76779 14.2139 7.40616 13.4405 7.27213Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Prediction details
                                </div>
                                <div className='predict_seting_line'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                        <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#8E8E93"/>
                                    </svg>
                                    Prediction
                                </div>
                                <div className='predict_seting_line'>
                                    {
                                        top3?
                                        <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                            <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                        </svg>

                                        :
                                        <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>


                                    }
                                    

                                    Top 3 metrics with  Positive & Negative impact  
                                </div>
                                <div className='predict_seting_line'>
                                    {
                                        impact?
                                        <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                            <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                        </svg>
                                        :
                                        <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    }
                                    

                                    Metrics impact 
                                </div>

                                {GlobalState?.activemodel?.lastTrain?.learningType.includes('binary')?
                                <>
                                    <div className='predict_seting_line predict_seting_line_title tut_d_none'>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.1642 12.0005C15.1642 14.0268 14.0242 15.1651 11.9996 15.1651C9.9733 15.1651 8.8333 14.0268 8.8333 12.0005M15.1642 12.0005C15.1642 9.97422 14.0242 8.83594 11.9996 8.83594C9.97501 8.83594 8.8333 9.97422 8.8333 12.0005M15.1642 12.0005H18.3287M8.8333 12.0005H5.67044M5.67044 12.0005C5.67044 13.2674 4.9573 13.9788 3.69215 13.9788C2.4253 13.9788 1.71387 13.2674 1.71387 12.0005C1.71387 10.7354 2.4253 10.0222 3.69215 10.0222C4.9573 10.0222 5.67044 10.7337 5.67044 12.0005ZM18.3287 12.0005C18.3287 10.7354 19.0402 10.0222 20.307 10.0222C21.5739 10.0222 22.2853 10.7337 22.2853 12.0005C22.2853 13.2674 21.5739 13.9788 20.307 13.9788C19.0419 13.9788 18.3287 13.2674 18.3287 12.0005Z" stroke="#007AFF" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>

                                        Threshold
                                    </div>
                                    <div className='predict_seting_line predict_seting_line_inputs'>
                                        <div>
                                            Lower
                                            <input
                                                type="text"
                                                value={lowerSeting}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(",", ".");

                                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                        setLowerSeting(value);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            Upper
                                            <input
                                                type="text"
                                                value={upperSeting}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(",", ".");

                                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                        setUpperSeting(value);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="threshold_box">
                                        <div className="threshold_box_top">
                                            <span>Segment thresholds</span>

                                            <button type="button" className="threshold_add_btn" onClick={addThresholdRow}>
                                            +
                                            </button>
                                        </div>

                                        <div className="threshold_rows_scroll">
                                            {thresholdRows.map((row) => (
                                            <div className="threshold_row" key={row.id}>
                                                <Select
                                                components={{ DropdownIndicator }}
                                                options={segmentOptions}
                                                styles={{
                                                    ...customStyles3,
                                                    menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 99999,
                                                    }),
                                                }}
                                                classNamePrefix="filter"
                                                className="selectproduct threshold_segment_select"
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                
                                                placeholder={<div className="selectplace active">Segment</div>}
                                                value={segmentOptions.find(opt => opt.value === row.segmentId) || null}
                                                onChange={(option) => updateThresholdRow(row.id, "segmentId", option.value)}
                                                />

                                                <div className="threshold_input_wrap">
                                                <span>Lower</span>
                                                <input
                                                    type="text"
                                                    value={row.lower}
                                                    onChange={(e) => updateThresholdRow(row.id, "lower", e.target.value)}
                                                />
                                                </div>

                                                <div className="threshold_input_wrap">
                                                <span>Upper</span>
                                                <input
                                                    type="text"
                                                    value={row.upper}
                                                    onChange={(e) => updateThresholdRow(row.id, "upper", e.target.value)}
                                                />
                                                </div>

                                                {thresholdRows.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="threshold_remove_btn"
                                                    onClick={() => removeThresholdRow(row.id)}
                                                >
                                                    ×
                                                </button>
                                                )}
                                            </div>
                                            ))}
                                        </div>
                                        </div> */}
                                </>
                                :
                                <></>
                                }


                                <div className="but_next_stepanalitics_line but_next_stepanalitics_line_seting">
                                    
                                    <div className="but_next_stepanalitics" onClick={()=>startmodel()}>{langv?.deploy?.text25}</div>
                                </div>
                            </>
                            :
                            <></>
                    }
                    {
                        statehead==2?
                            <>
                                <TableExcelAnalitics {...{ attachments, save, nameDataset, setnameDataset, objectid, setObjectid, setStatehead, dataid, setDataid, activebut, typeBigquery, typeCSWquery, setLoad, timedata, setTimedata }}/>
                                {
                                    activebut==1?
                                    <div className="but_next_stepanalitics_line">
                                        <div className="but_next_stepanalitics" onClick={()=>setStatehead0(2.5)}>{langv?.deploy?.text24}</div>
                                    </div>
                                    :
                                    <div className="but_next_stepanalitics_line">
                                        {/* onClick={()=>startmodel()} */}
                                        <div className="but_next_stepanalitics" onClick={()=>setStatehead0(2.1)}>{langv?.deploy?.text24}</div>
                                    </div>
                                }
                                
                            </>
                            :
                            <></>
                    }
                    {
                        statehead==5?
                            <div className='shedule'>
                                <div className='d-flex-deploy'>
                                    <div className='w-50-deploy'>
                                        <div className='predict_seting_line predict_seting_line_title'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.6476 8.33398C9.70071 9.05188 8.80474 9.83457 7.96615 10.6764C4.01483 14.6264 2.01417 19.0306 3.49521 20.5116C4.97626 21.9927 9.38051 19.992 13.3304 16.0407C14.1723 15.2021 14.955 14.3062 15.6729 13.3593" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15.6715 13.3559C18.0015 16.4486 18.9504 19.3593 17.8 20.5097C16.3176 21.9908 11.9147 19.9901 7.9634 16.0388C4.01486 12.0888 2.0142 7.68461 3.49525 6.20356C4.64424 5.05318 7.55354 6.0021 10.6462 8.33204" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.95215 13.3548C9.95215 13.5391 10.0253 13.7158 10.1556 13.846C10.2859 13.9763 10.4626 14.0495 10.6468 14.0495C10.8311 14.0495 11.0078 13.9763 11.138 13.846C11.2683 13.7158 11.3415 13.5391 11.3415 13.3548C11.3415 13.1706 11.2683 12.9939 11.138 12.8636C11.0078 12.7333 10.8311 12.6602 10.6468 12.6602C10.4626 12.6602 10.2859 12.7333 10.1556 12.8636C10.0253 12.9939 9.95215 13.1706 9.95215 13.3548Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.4405 7.27213C13.0029 7.1971 13.0029 6.57051 13.4405 6.49409C14.2137 6.36016 14.9294 5.99873 15.4961 5.45601C16.0629 4.91328 16.4549 4.2139 16.6222 3.44724L16.6486 3.32637C16.743 2.89567 17.3571 2.89289 17.4544 3.32359L17.4877 3.46253C17.6621 4.22539 18.0579 4.91978 18.6254 5.45859C19.1928 5.99741 19.9068 6.35667 20.6777 6.49131C21.1167 6.56912 21.1167 7.19849 20.6777 7.27491C19.9068 7.40955 19.1928 7.76881 18.6254 8.30762C18.0579 8.84644 17.6621 9.54083 17.4877 10.3037L17.4544 10.4426C17.3571 10.8733 16.743 10.8719 16.6486 10.4398L16.6208 10.3204C16.4538 9.55345 16.0618 8.85377 15.4951 8.31078C14.9283 7.76779 14.2139 7.40616 13.4405 7.27213Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Prediction details
                                        </div>
                                        <div className='predict_seting_line'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#8E8E93"/>
                                            </svg>
                                            Prediction
                                        </div>
                                        <div className='predict_seting_line'>
                                            {
                                                top3?
                                                <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                                    <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                                </svg>

                                                :
                                                <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>


                                            }
                                            

                                            Top 3 metrics with  Positive & Negative impact  
                                        </div>
                                        <div className='predict_seting_line'>
                                            {
                                                impact?
                                                <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                                    <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                                </svg>
                                                :
                                                <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            }
                                            

                                            Metrics impact 
                                        </div>
                                        <div className='predict_seting_line predict_seting_line_title'style={{marginTop:"8px"}}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.5998 10.2004C9.5998 10.0413 9.53659 9.88865 9.42407 9.77613C9.31155 9.6636 9.15893 9.60039 8.9998 9.60039C8.84067 9.60039 8.68806 9.6636 8.57554 9.77613C8.46302 9.88865 8.3998 10.0413 8.3998 10.2004V18.6004C8.3998 18.7595 8.46302 18.9121 8.57554 19.0247C8.68806 19.1372 8.84067 19.2004 8.9998 19.2004C9.15893 19.2004 9.31155 19.1372 9.42407 19.0247C9.53659 18.9121 9.5998 18.7595 9.5998 18.6004V10.2004ZM11.9998 14.4004C12.1589 14.4004 12.3115 14.4636 12.4241 14.5761C12.5366 14.6886 12.5998 14.8413 12.5998 15.0004V18.6004C12.5998 18.7595 12.5366 18.9121 12.4241 19.0247C12.3115 19.1372 12.1589 19.2004 11.9998 19.2004C11.8407 19.2004 11.6881 19.1372 11.5755 19.0247C11.463 18.9121 11.3998 18.7595 11.3998 18.6004V15.0004C11.3998 14.8413 11.463 14.6886 11.5755 14.5761C11.6881 14.4636 11.8407 14.4004 11.9998 14.4004ZM15.5998 12.6004C15.5998 12.4413 15.5366 12.2886 15.4241 12.1761C15.3115 12.0636 15.1589 12.0004 14.9998 12.0004C14.8407 12.0004 14.6881 12.0636 14.5755 12.1761C14.463 12.2886 14.3998 12.4413 14.3998 12.6004V18.6004C14.3998 18.7595 14.463 18.9121 14.5755 19.0247C14.6881 19.1372 14.8407 19.2004 14.9998 19.2004C15.1589 19.2004 15.3115 19.1372 15.4241 19.0247C15.5366 18.9121 15.5998 18.7595 15.5998 18.6004V12.6004ZM4.7998 4.80039C4.7998 4.16387 5.05266 3.55342 5.50275 3.10333C5.95284 2.65325 6.56328 2.40039 7.1998 2.40039H12.703C13.1802 2.40081 13.6378 2.59073 13.975 2.92839L18.673 7.62519C19.0102 7.96263 19.1997 8.42013 19.1998 8.89719V19.2004C19.1998 19.8369 18.9469 20.4474 18.4969 20.8974C18.0468 21.3475 17.4363 21.6004 16.7998 21.6004H7.1998C6.56328 21.6004 5.95284 21.3475 5.50275 20.8974C5.05266 20.4474 4.7998 19.8369 4.7998 19.2004V4.80039ZM7.1998 3.60039C6.88154 3.60039 6.57632 3.72682 6.35128 3.95186C6.12623 4.17691 5.9998 4.48213 5.9998 4.80039V19.2004C5.9998 19.5187 6.12623 19.8239 6.35128 20.0489C6.57632 20.274 6.88154 20.4004 7.1998 20.4004H16.7998C17.1181 20.4004 17.4233 20.274 17.6483 20.0489C17.8734 19.8239 17.9998 19.5187 17.9998 19.2004V9.60039H13.7998C13.3224 9.60039 12.8646 9.41075 12.527 9.07318C12.1894 8.73562 11.9998 8.27778 11.9998 7.80039V3.60039H7.1998ZM13.7998 8.40039H17.7514L13.1998 3.84879V7.80039C13.1998 7.95952 13.263 8.11213 13.3755 8.22465C13.4881 8.33718 13.6407 8.40039 13.7998 8.40039Z" fill="#007AFF"/>
                                            </svg>

                                            Datasets
                                        </div>
                                        <div className='shedule_line1' style={{marginBottom: '22px'}}>
                                            <input  type="text" placeholder="Input Table" class="pop-input datasetname" style={{width: "320px", minWidth: 'calc(50% - 30px)'}} value={GlobalState.inputDatasetname} />
                                            <input  type="text" placeholder="Output Table" class="pop-input datasetname" style={{width: "320px", marginLeft:"20px", minWidth: 'calc(50% - 30px)'}} value={GlobalState.outputDatasetname} />
                                        </div>
                                        <div className='predict_seting_line predict_seting_line_title'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22.125 4.5H18V1.875H16.5V4.5H7.5V1.875H6V4.5H1.875C1.57675 4.50037 1.29081 4.61902 1.07992 4.82992C0.869018 5.04081 0.750372 5.32675 0.75 5.625V21.375C0.750372 21.6733 0.869018 21.9592 1.07992 22.1701C1.29081 22.381 1.57675 22.4996 1.875 22.5H22.125C22.4233 22.4996 22.7092 22.381 22.9201 22.1701C23.131 21.9592 23.2496 21.6733 23.25 21.375V5.625C23.2496 5.32675 23.131 5.04081 22.9201 4.82992C22.7092 4.61902 22.4233 4.50037 22.125 4.5ZM21.75 21H2.25V6H6V7.875H7.5V6H16.5V7.875H18V6H21.75V21Z" fill="#007AFF"/>
                                                <path d="M5.25 10.5H6.75V12H5.25V10.5ZM9.375 10.5H10.875V12H9.375V10.5ZM13.125 10.5H14.625V12H13.125V10.5ZM17.25 10.5H18.75V12H17.25V10.5ZM5.25 13.875H6.75V15.375H5.25V13.875ZM9.375 13.875H10.875V15.375H9.375V13.875ZM13.125 13.875H14.625V15.375H13.125V13.875ZM17.25 13.875H18.75V15.375H17.25V13.875ZM5.25 17.25H6.75V18.75H5.25V17.25ZM9.375 17.25H10.875V18.75H9.375V17.25ZM13.125 17.25H14.625V18.75H13.125V17.25ZM17.25 17.25H18.75V18.75H17.25V17.25Z" fill="#007AFF"/>
                                            </svg>
                                            Schedule
                                        </div>
                                    </div>
                                    {GlobalState?.activemodel?.lastTrain?.learningType.includes('binary')?
                                
                                        <div className='w-50-deploy'>
                                            <div className='predict_seting_line predict_seting_line_title tut_d_none'>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.1642 12.0005C15.1642 14.0268 14.0242 15.1651 11.9996 15.1651C9.9733 15.1651 8.8333 14.0268 8.8333 12.0005M15.1642 12.0005C15.1642 9.97422 14.0242 8.83594 11.9996 8.83594C9.97501 8.83594 8.8333 9.97422 8.8333 12.0005M15.1642 12.0005H18.3287M8.8333 12.0005H5.67044M5.67044 12.0005C5.67044 13.2674 4.9573 13.9788 3.69215 13.9788C2.4253 13.9788 1.71387 13.2674 1.71387 12.0005C1.71387 10.7354 2.4253 10.0222 3.69215 10.0222C4.9573 10.0222 5.67044 10.7337 5.67044 12.0005ZM18.3287 12.0005C18.3287 10.7354 19.0402 10.0222 20.307 10.0222C21.5739 10.0222 22.2853 10.7337 22.2853 12.0005C22.2853 13.2674 21.5739 13.9788 20.307 13.9788C19.0419 13.9788 18.3287 13.2674 18.3287 12.0005Z" stroke="#007AFF" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>

                                                Threshold
                                            </div>
                                            <div className='predict_seting_line predict_seting_line_inputs'>
                                                <div>
                                                    Lower
                                                    <input
                                                        type="text"
                                                        value={lowerSeting}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(",", ".");

                                                            if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                                setLowerSeting(value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    Upper
                                                    <input
                                                        type="text"
                                                        value={upperSeting}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(",", ".");

                                                            if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                                setUpperSeting(value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="threshold_box">
                                                <div className="threshold_box_top">
                                                    <span>Segment thresholds</span>

                                                    <button type="button" className="threshold_add_btn" onClick={addThresholdRow}>
                                                    +
                                                    </button>
                                                </div>

                                                <div className="threshold_rows_scroll">
                                                    {thresholdRows.map((row) => (
                                                    <div className="threshold_row" key={row.id}>
                                                        {row.isOther ? (
                                                            <div className="threshold_other_label">Other</div>
                                                        ) : (
                                                            <Select
                                                                components={{ DropdownIndicator }}
                                                                options={segmentOptions}
                                                                styles={{
                                                                    ...customStyles3,
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 99999,
                                                                    }),
                                                                }}
                                                                classNamePrefix="filter"
                                                                className="selectproduct threshold_segment_select"
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                placeholder={<div className="selectplace active">Segment</div>}
                                                                value={segmentOptions.find(opt => opt.value === row.segmentId) || null}
                                                                onChange={(option) => updateThresholdRow(row.id, "segmentId", option.value)}
                                                            />
                                                        )}

                                                        <div className="threshold_input_wrap">
                                                        <span>Lower</span>
                                                        <input
                                                            type="text"
                                                            value={row.lower}
                                                            onChange={(e) => updateThresholdRow(row.id, "lower", e.target.value)}
                                                        />
                                                        </div>

                                                        <div className="threshold_input_wrap">
                                                        <span>Upper</span>
                                                        <input
                                                            type="text"
                                                            value={row.upper}
                                                            onChange={(e) => updateThresholdRow(row.id, "upper", e.target.value)}
                                                        />
                                                        </div>

                                                        {thresholdRows.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="threshold_remove_btn"
                                                            onClick={() => removeThresholdRow(row.id)}
                                                        >
                                                            ×
                                                        </button>
                                                        )}
                                                    </div>
                                                    ))}
                                                </div>
                                                </div> */}
                                        </div>
                                        :
                                        <></>
                                    }
                                </div>




                                


                                <div className='shedule_line2' style={{marginBottom: '20px'}}>
                                    <div className='shedule_line2_col1' style={{minWidth: 'max-content'}}>
                                        {langv?.deploy?.text31}
                                    </div>
                                    <div className='shedule_line2_col2'>
                                        <input id="website" type="text" placeholder="1" class="input_every" value={"1"} style={{width: '52px', outline: 'none', border: 'none !important', borderRadius: '8px'}} onChange={(event) => setnameDataset(event.target.value)}></input>
                                    </div>
                                    <div className='shedule_line2_col3'>
                                        <Select 
                                            components={{ DropdownIndicator }}
                                            options={days} 
                                            styles={customStyles3} 
                                            classNamePrefix='filter'
                                            className='selectproduct'
                                              
                                            placeholder="Select every"
                                            onChange={(option) => setEvery(option.value)}
                                        />
                                        
                                    </div>
                                </div>
                                <div className='shedule_line3'>
                                    <div className='date_shedule'>
                                       
                                        <div className='shedule_line3_col1' style={{minWidth: 'max-content'}}>
                                        Select Start Date
                                        </div>
                                        <div className='shedule_line3_col2' style={{position: 'relative', zIndex: '99999999'}}>
                                            <DatePicker selected={startDate} minDate={new Date().toISOString().split('T')[0]} dateFormat="YYYY-MM-dd" onChange={(date) => setStartDate(date)} />
                                        </div>
                                    </div>
                                    <div className='time_shedule'>
                                        <div className='shedule_line3_col4'>
                                        {langv?.deploy?.text33}
                                        </div>
                                        <div className='shedule_line3_col5'>
                                            <Select 
                                                components={{ DropdownIndicator }}
                                                options={hours} 
                                                styles={customStyles4} 
                                                classNamePrefix='filter'
                                                className='selectproduct'
                                                  
                                                placeholder={<div className='selectplace active'>01</div>}
                                                onChange={(option) => setHour(option.value)}
                                            />
                                        </div>
                                        <div className='shedule_line3_col4'>
                                        {langv?.deploy?.text34}
                                        </div>
                                        <div className='shedule_line3_col5'>
                                            <Select 
                                                components={{ DropdownIndicator }}
                                                options={minuts} 
                                                styles={customStyles4} 
                                                classNamePrefix='filter'
                                                className='selectproduct'
                                                  
                                                placeholder={<div className='selectplace active'>00</div>}
                                                onChange={(option) => setMinut(option.value)}
                                            />
                                        </div>

                                        <div className='checkpolden'>
                                            <span className={polden==1?"active":<></>} onClick={()=>setPolden(1)}>AM</span>
                                            <span className={polden==2?"active":<></>} onClick={()=>setPolden(2)}>PM</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="but_next_stepanalitics_line but_next_stepanalitics_line_seting">
                                    
                                    <div className={statehead>4&&every!=''?'but_next_stepanalitics':'but_next_stepanalitics inactive'} onClick={()=>changesavemodel()}>{langv?.deploy?.text25}</div>
                                </div>
                            </div>
                            :
                            <></>
                    }
                    {
                        statehead==5.5?
                            <div className='shedule'>
                                <div className='d-flex-deploy'>
                                    <div className='w-50-deploy'>
                                        <div className='predict_seting_line predict_seting_line_title'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.6476 8.33398C9.70071 9.05188 8.80474 9.83457 7.96615 10.6764C4.01483 14.6264 2.01417 19.0306 3.49521 20.5116C4.97626 21.9927 9.38051 19.992 13.3304 16.0407C14.1723 15.2021 14.955 14.3062 15.6729 13.3593" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15.6715 13.3559C18.0015 16.4486 18.9504 19.3593 17.8 20.5097C16.3176 21.9908 11.9147 19.9901 7.9634 16.0388C4.01486 12.0888 2.0142 7.68461 3.49525 6.20356C4.64424 5.05318 7.55354 6.0021 10.6462 8.33204" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.95215 13.3548C9.95215 13.5391 10.0253 13.7158 10.1556 13.846C10.2859 13.9763 10.4626 14.0495 10.6468 14.0495C10.8311 14.0495 11.0078 13.9763 11.138 13.846C11.2683 13.7158 11.3415 13.5391 11.3415 13.3548C11.3415 13.1706 11.2683 12.9939 11.138 12.8636C11.0078 12.7333 10.8311 12.6602 10.6468 12.6602C10.4626 12.6602 10.2859 12.7333 10.1556 12.8636C10.0253 12.9939 9.95215 13.1706 9.95215 13.3548Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.4405 7.27213C13.0029 7.1971 13.0029 6.57051 13.4405 6.49409C14.2137 6.36016 14.9294 5.99873 15.4961 5.45601C16.0629 4.91328 16.4549 4.2139 16.6222 3.44724L16.6486 3.32637C16.743 2.89567 17.3571 2.89289 17.4544 3.32359L17.4877 3.46253C17.6621 4.22539 18.0579 4.91978 18.6254 5.45859C19.1928 5.99741 19.9068 6.35667 20.6777 6.49131C21.1167 6.56912 21.1167 7.19849 20.6777 7.27491C19.9068 7.40955 19.1928 7.76881 18.6254 8.30762C18.0579 8.84644 17.6621 9.54083 17.4877 10.3037L17.4544 10.4426C17.3571 10.8733 16.743 10.8719 16.6486 10.4398L16.6208 10.3204C16.4538 9.55345 16.0618 8.85377 15.4951 8.31078C14.9283 7.76779 14.2139 7.40616 13.4405 7.27213Z" stroke="#007AFF" stroke-width="1.38935" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Prediction details
                                        </div>
                                        <div className='predict_seting_line'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#8E8E93"/>
                                            </svg>
                                            Prediction
                                        </div>
                                        <div className='predict_seting_line'>
                                            {
                                                top3?
                                                <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                                    <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                                </svg>

                                                :
                                                <svg onClick={()=>setTop3(!top3)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>


                                            }
                                            

                                            Top 3 metrics with  Positive & Negative impact  
                                        </div>
                                        <div className='predict_seting_line'>
                                            {
                                                impact?
                                                <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.59961" y="3.59961" width="16.8" height="16.8" rx="2" fill="#787880" fill-opacity="0.2"/>
                                                    <path d="M6.25 3C5.38805 3 4.5614 3.34241 3.9519 3.9519C3.34241 4.5614 3 5.38805 3 6.25V17.75C3 18.612 3.34241 19.4386 3.9519 20.0481C4.5614 20.6576 5.38805 21 6.25 21H17.75C18.612 21 19.4386 20.6576 20.0481 20.0481C20.6576 19.4386 21 18.612 21 17.75V6.25C21 5.38805 20.6576 4.5614 20.0481 3.9519C19.4386 3.34241 18.612 3 17.75 3H6.25ZM4.5 6.25C4.5 5.284 5.284 4.5 6.25 4.5H17.75C18.716 4.5 19.5 5.284 19.5 6.25V17.75C19.5 18.2141 19.3156 18.6592 18.9874 18.9874C18.6592 19.3156 18.2141 19.5 17.75 19.5H6.25C5.78587 19.5 5.34075 19.3156 5.01256 18.9874C4.68437 18.6592 4.5 18.2141 4.5 17.75V6.25ZM17.28 9.28C17.3537 9.21134 17.4128 9.12854 17.4538 9.03654C17.4948 8.94454 17.5168 8.84523 17.5186 8.74452C17.5204 8.64382 17.5018 8.54379 17.4641 8.4504C17.4264 8.35701 17.3703 8.27218 17.299 8.20096C17.2278 8.12974 17.143 8.0736 17.0496 8.03588C16.9562 7.99816 16.8562 7.97963 16.7555 7.98141C16.6548 7.98319 16.5555 8.00523 16.4635 8.04622C16.3715 8.08721 16.2887 8.14631 16.22 8.22L9.997 14.436L7.78 12.22C7.63783 12.0875 7.44978 12.0154 7.25548 12.0188C7.06118 12.0223 6.87579 12.101 6.73838 12.2384C6.60097 12.3758 6.52225 12.5612 6.51883 12.7555C6.5154 12.9498 6.58752 13.1378 6.72 13.28L9.465 16.026C9.60563 16.1664 9.79625 16.2453 9.995 16.2453C10.1938 16.2453 10.3844 16.1664 10.525 16.026L17.28 9.28Z" fill="#34C759"/>
                                                </svg>
                                                :
                                                <svg onClick={()=>setImpact(!impact)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="3.60156" y="3.60156" width="16.8" height="16.8" rx="2" fill="#3C3C43" fill-opacity="0.6"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 4H17.7143C18.3205 4 18.9019 4.24082 19.3305 4.66947C19.7592 5.09812 20 5.67951 20 6.28571V17.7143C20 18.3205 19.7592 18.9019 19.3305 19.3305C18.9019 19.7592 18.3205 20 17.7143 20H6.28571C5.67951 20 5.09812 19.7592 4.66947 19.3305C4.24082 18.9019 4 18.3205 4 17.7143V6.28571C4 5.67951 4.24082 5.09812 4.66947 4.66947C5.09812 4.24082 5.67951 4 6.28571 4Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            }
                                            

                                            Metrics impact 
                                        </div>
                                    </div>
                                    <div className='w-50-deploy'>
                                        {GlobalState?.activemodel?.lastTrain?.learningType.includes('binary')?
                                        <>
                                        <div className='predict_seting_line predict_seting_line_title tut_d_none'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.1642 12.0005C15.1642 14.0268 14.0242 15.1651 11.9996 15.1651C9.9733 15.1651 8.8333 14.0268 8.8333 12.0005M15.1642 12.0005C15.1642 9.97422 14.0242 8.83594 11.9996 8.83594C9.97501 8.83594 8.8333 9.97422 8.8333 12.0005M15.1642 12.0005H18.3287M8.8333 12.0005H5.67044M5.67044 12.0005C5.67044 13.2674 4.9573 13.9788 3.69215 13.9788C2.4253 13.9788 1.71387 13.2674 1.71387 12.0005C1.71387 10.7354 2.4253 10.0222 3.69215 10.0222C4.9573 10.0222 5.67044 10.7337 5.67044 12.0005ZM18.3287 12.0005C18.3287 10.7354 19.0402 10.0222 20.307 10.0222C21.5739 10.0222 22.2853 10.7337 22.2853 12.0005C22.2853 13.2674 21.5739 13.9788 20.307 13.9788C19.0419 13.9788 18.3287 13.2674 18.3287 12.0005Z" stroke="#007AFF" stroke-width="1.71429" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                            Threshold
                                        </div>
                                        <div className='predict_seting_line predict_seting_line_inputs'>
                                            <div>
                                                Lower
                                                <input
                                                    type="text"
                                                    value={lowerSeting}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(",", ".");

                                                        if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                            setLowerSeting(value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                Upper
                                                <input
                                                    type="text"
                                                    value={upperSeting}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(",", ".");

                                                        if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                            setUpperSeting(value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="threshold_box">
                                            <div className="threshold_box_top">
                                                <span>Segment thresholds</span>

                                                <button type="button" className="threshold_add_btn" onClick={addThresholdRow}>
                                                +
                                                </button>
                                            </div>

                                            <div className="threshold_rows_scroll">
                                                {thresholdRows.map((row) => (
                                                <div className="threshold_row" key={row.id}>
                                                    {row.isOther ? (
                                                            <div className="threshold_other_label">Other</div>
                                                        ) : (
                                                            <Select
                                                                components={{ DropdownIndicator }}
                                                                options={segmentOptions}
                                                                styles={{
                                                                    ...customStyles3,
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 99999,
                                                                    }),
                                                                }}
                                                                classNamePrefix="filter"
                                                                className="selectproduct threshold_segment_select"
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                                placeholder={<div className="selectplace active">Segment</div>}
                                                                value={segmentOptions.find(opt => opt.value === row.segmentId) || null}
                                                                onChange={(option) => updateThresholdRow(row.id, "segmentId", option.value)}
                                                            />
                                                        )}

                                                    <div className="threshold_input_wrap">
                                                    <span>Lower</span>
                                                    <input
                                                        type="text"
                                                        value={row.lower}
                                                        onChange={(e) => updateThresholdRow(row.id, "lower", e.target.value)}
                                                    />
                                                    </div>

                                                    <div className="threshold_input_wrap">
                                                    <span>Upper</span>
                                                    <input
                                                        type="text"
                                                        value={row.upper}
                                                        onChange={(e) => updateThresholdRow(row.id, "upper", e.target.value)}
                                                    />
                                                    </div>

                                                    {thresholdRows.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="threshold_remove_btn"
                                                        onClick={() => removeThresholdRow(row.id)}
                                                    >
                                                        ×
                                                    </button>
                                                    )}
                                                </div>
                                                ))}
                                            </div>
                                            </div> */}
                                        </>
                                        :
                                        <></>
                                        }
                                    </div>
                                </div>
                                {/* <div className='predict_seting_line predict_seting_line_title'style={{marginTop:"8px"}}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5998 10.2004C9.5998 10.0413 9.53659 9.88865 9.42407 9.77613C9.31155 9.6636 9.15893 9.60039 8.9998 9.60039C8.84067 9.60039 8.68806 9.6636 8.57554 9.77613C8.46302 9.88865 8.3998 10.0413 8.3998 10.2004V18.6004C8.3998 18.7595 8.46302 18.9121 8.57554 19.0247C8.68806 19.1372 8.84067 19.2004 8.9998 19.2004C9.15893 19.2004 9.31155 19.1372 9.42407 19.0247C9.53659 18.9121 9.5998 18.7595 9.5998 18.6004V10.2004ZM11.9998 14.4004C12.1589 14.4004 12.3115 14.4636 12.4241 14.5761C12.5366 14.6886 12.5998 14.8413 12.5998 15.0004V18.6004C12.5998 18.7595 12.5366 18.9121 12.4241 19.0247C12.3115 19.1372 12.1589 19.2004 11.9998 19.2004C11.8407 19.2004 11.6881 19.1372 11.5755 19.0247C11.463 18.9121 11.3998 18.7595 11.3998 18.6004V15.0004C11.3998 14.8413 11.463 14.6886 11.5755 14.5761C11.6881 14.4636 11.8407 14.4004 11.9998 14.4004ZM15.5998 12.6004C15.5998 12.4413 15.5366 12.2886 15.4241 12.1761C15.3115 12.0636 15.1589 12.0004 14.9998 12.0004C14.8407 12.0004 14.6881 12.0636 14.5755 12.1761C14.463 12.2886 14.3998 12.4413 14.3998 12.6004V18.6004C14.3998 18.7595 14.463 18.9121 14.5755 19.0247C14.6881 19.1372 14.8407 19.2004 14.9998 19.2004C15.1589 19.2004 15.3115 19.1372 15.4241 19.0247C15.5366 18.9121 15.5998 18.7595 15.5998 18.6004V12.6004ZM4.7998 4.80039C4.7998 4.16387 5.05266 3.55342 5.50275 3.10333C5.95284 2.65325 6.56328 2.40039 7.1998 2.40039H12.703C13.1802 2.40081 13.6378 2.59073 13.975 2.92839L18.673 7.62519C19.0102 7.96263 19.1997 8.42013 19.1998 8.89719V19.2004C19.1998 19.8369 18.9469 20.4474 18.4969 20.8974C18.0468 21.3475 17.4363 21.6004 16.7998 21.6004H7.1998C6.56328 21.6004 5.95284 21.3475 5.50275 20.8974C5.05266 20.4474 4.7998 19.8369 4.7998 19.2004V4.80039ZM7.1998 3.60039C6.88154 3.60039 6.57632 3.72682 6.35128 3.95186C6.12623 4.17691 5.9998 4.48213 5.9998 4.80039V19.2004C5.9998 19.5187 6.12623 19.8239 6.35128 20.0489C6.57632 20.274 6.88154 20.4004 7.1998 20.4004H16.7998C17.1181 20.4004 17.4233 20.274 17.6483 20.0489C17.8734 19.8239 17.9998 19.5187 17.9998 19.2004V9.60039H13.7998C13.3224 9.60039 12.8646 9.41075 12.527 9.07318C12.1894 8.73562 11.9998 8.27778 11.9998 7.80039V3.60039H7.1998ZM13.7998 8.40039H17.7514L13.1998 3.84879V7.80039C13.1998 7.95952 13.263 8.11213 13.3755 8.22465C13.4881 8.33718 13.6407 8.40039 13.7998 8.40039Z" fill="#007AFF"/>
                                    </svg>

                                    Datasets
                                </div>
                                <div className='shedule_line1' style={{marginBottom: '22px'}}>
                                    <input  type="text" placeholder="Input Table" class="pop-input datasetname" style={{width: "320px"}} value={GlobalState.inputDatasetname} />
                                    <input  type="text" placeholder="Output Table" class="pop-input datasetname" style={{width: "320px", marginLeft:"20px"}} value={GlobalState.outputDatasetname} />
                                </div>                    */}
                                <div className="but_next_stepanalitics_line but_next_stepanalitics_line_seting">
                                    
                                    <div className={statehead>4&&every!=''?'but_next_stepanalitics':'but_next_stepanalitics inactive'} onClick={()=>changesavemodel2()}>{langv?.deploy?.text25}</div>
                                </div>
                            </div>
                            :
                            <></>
                    }
                    {
                        statehead==6?
                        <></>
                        :
                        <></>
                    }
                </div>
            </div>
        </div>
    );
});

export default PopupInfo;
